import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="documents-form"
export default class extends Controller {
  static targets = ["globalCheckbox", "userCheckbox", "deleteAllCheckbox", "deleteFileCheckbox", "groupSelect", "userOption", "emptyGroupHint"];

  connect() {
    this.applyGroupFilter();
  }

  toggleUsers() {
    const checked = this.globalCheckboxTarget.checked;
    this.visibleUserCheckboxes().forEach((cb) => (cb.checked = checked));
  }

  groupChanged() {
    this.applyGroupFilter();
  }

  userChanged() {
    const visibleCheckboxes = this.visibleUserCheckboxes();
    if (!visibleCheckboxes.length || !visibleCheckboxes.every((cb) => cb.checked)) {
      this.globalCheckboxTarget.checked = false;
    }
  }

  toggleDeleteAll() {
    const checked = this.deleteAllCheckboxTarget.checked;
    this.deleteFileCheckboxTargets.forEach((cb) => (cb.checked = checked));
  }

  deleteFileChanged() {
    this.deleteAllCheckboxTarget.checked =
      this.deleteFileCheckboxTargets.every((cb) => cb.checked);
  }

  applyGroupFilter() {
    if (!this.hasGroupSelectTarget) return;

    const selectedGroupId = this.groupSelectTarget.value;
    let visibleOptionsCount = 0;

    this.userOptionTargets.forEach((option) => {
      const matchesGroup = selectedGroupId.length > 0 && option.dataset.groupId === selectedGroupId;
      option.hidden = !matchesGroup;
      option.setAttribute("aria-hidden", matchesGroup ? "false" : "true");

      const checkbox = option.querySelector('input[type="checkbox"]');
      if (checkbox) {
        checkbox.disabled = !matchesGroup;
        if (!matchesGroup) checkbox.checked = false;
      }
      if (matchesGroup) visibleOptionsCount += 1;
    });

    if (this.hasEmptyGroupHintTarget) this.emptyGroupHintTarget.hidden = visibleOptionsCount > 0;

    const visibleCheckboxes = this.visibleUserCheckboxes();
    const noUsers = visibleOptionsCount === 0;
    this.globalCheckboxTarget.checked = !noUsers && visibleCheckboxes.every((cb) => cb.checked);
    this.globalCheckboxTarget.disabled = noUsers;
    this.globalCheckboxTarget.closest("label").style.display = noUsers ? "none" : "";
  }

  visibleUserCheckboxes() {
    return this.userCheckboxTargets.filter((checkbox) => !checkbox.closest("label")?.hidden);
  }
}
